import {useState} from 'react'
import {PageHeader} from '../components/ui/page-header'
import {SignSidebar} from '../components/konstruktors/SignSidebar'
import {SignWizard} from '../components/konstruktors/SignWizard'
import {SIGNS, type SignCode} from '../lib/sign-catalog'
import {lvsRef} from '../lib/utils'

export function KonstruktorsPage() {
    const [activeCode, setActiveCode] = useState<SignCode | null>(null)
    const def = activeCode ? SIGNS[activeCode] : null

    return (
        <div className='flex gap-10 min-h-[calc(100vh-14rem)]'>
            <SignSidebar
                activeCode={activeCode}
                onSelect={setActiveCode}
            />

            <div className='flex-1 min-w-0 space-y-8'>
                {def ?
                    <>
                        <PageHeader
                            eyebrow={`KONSTRUKTORS / LVS 77-3:2016 / ${def.lvsRefs.map(r => lvsRef(r, 'clause')).join(', ')}`}
                            title={def.label}
                        />
                        <SignWizard def={def} />
                    </>
                :   <PageHeader
                        eyebrow='KONSTRUKTORS'
                        title='Izvēlies zīmi'
                        subtitle='Izvēlies zīmes kodu no saraksta pa kreisi, lai uzsāktu konstruēšanu.'
                    />
                }
            </div>
        </div>
    )
}
